import React, { VFC } from 'react';
import styled from 'styled-components';
import { theme } from '../../utils/theme';
import Typography from '../atoms/Typography';

interface Props extends React.HTMLProps<HTMLDivElement> {
  title: string;
}

interface IStyledDiv {
  backgroundColor?: string;
  borderColor?: string;
}

const StyledDiv = styled.div<IStyledDiv>`
  border-radius: 4px;
  padding: 2px 4px;
  background-color: ${({ backgroundColor }) => backgroundColor || 'grey'};
  border: 1px solid ${({ borderColor }) => borderColor || 'grey'};
  overflow: hidden;
  display: inline-flex;
`;

const StyledTypo = styled(Typography)`
  display: inline;
`;

const StatusBox: VFC<Props> = ({ title }) => {
  const getColor = () => {
    switch (title) {
      case 'label_returnable':
        return {
          bg: theme.colors.green[20],
          border: theme.colors.green[100],
        };
      default:
        return {
          bg: theme.colors.red[20],
          border: theme.colors.red[100],
        };
    }
  };

  return (
    <StyledDiv backgroundColor={getColor().bg} borderColor={getColor().border}>
      <StyledTypo
        translateKey={title}
        align="center"
        variant="status-message"
        color={theme.colors.grey[100]}
      />
    </StyledDiv>
  );
};

export default StatusBox;
